import React from 'react';
import {
  removeNodes,
} from '@udecode/plate';
import { useEditorRef, findNodePath, focusEditor } from '@udecode/plate-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

export const RemoveNodeButton = ({
  element,
  children,
  className,
  showIcon = true,
  ...props
}) => {
  const editor = useEditorRef();


  return (
    <button
      className={clsx(className, 'button--popover', 'button--unstyled')}
      onClick={() => {
        const path = findNodePath(editor, element);

        removeNodes(editor, { at: path });
        setTimeout(() => {
          focusEditor(editor, editor.selection);
        }, 0);
      }}
      onMouseDown={(e) => e.preventDefault()}
      {...props}
    >
      {showIcon && (
        <FontAwesomeIcon icon={['fa', 'trash-alt']} />
      )}
      {children}
    </button>
  );
};
